import Vue from 'vue';

export default {
  async get(filter) {
    return (await Vue.http.post('/api/transactions/list', filter)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/transaction.service.js